export const navigation = {
  montessori: "Montessori",
  openHouse: "Open House",
  contact: "Contact",
  aboutUs: "About Us",
  prices: "Prices",
  school: {
    main: "School",
    aboutUs: "About Us",
    montessori: "Montessori Education",
    trilingual: "Trilingual Education"
  },
  schoolLife: {
    main: "School Life",
    calendar: "School Calendar",
    extracurriculars: "Extracurriculars",
    services: "Services"
  },
  admissions: {
    main: "Admissions",
    process: "Admissions Process",
    prices: "Prices & Fees",
    visit: "Visit the School",
    openHouse: "Open House"
  },
  activities: {
    main: "Activities",
    birthdays: "Birthdays",
    easterCamp: "Easter Camp",
    summerCamp: "Summer Camp",
    christmasCamp: "Christmas Camp",
    courses: "Courses"
  },
  extracurriculars: "Extracurriculars",
  courses: "Courses",
  camps: {
    main: "Camps",
    easter: "Easter",
    summer: "Summer"
  }
};
